import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Flex, Popover, Text } from '@olist/united';

export const PlanSelectorContainer = styled(Flex)`
  height: 100%;
  width: 100%;
`;

export const PlanSelector = styled(Flex)`
  border: 1px solid #d1d1e3;
  border-radius: 16px;
  height: 100%;
  padding: 40px 30px 40px 30px;
  width: 100%;
`;

export const CustomPopover = styled(Popover)`
  background-color: ${themeGet('colors.foundation.infoLight')};
  flex: 1;
  margin: 18px 0;
  padding: 4px 16px;

  h5 {
    color: ${themeGet('colors.foundation.infoDark')};
    font-size: 14px;
    font-weight: 400;
  }

  ::after {
    border-top-color: ${themeGet('colors.foundation.infoDark')};
  }
`;

export const PlanSelectorButtonTooltip = styled(Popover)`
  background-color: ${themeGet('colors.blueDarker')};
  cursor: initial;
  &::before,
  &::after {
    border-bottom-color: ${themeGet('colors.blueDarker')};
  }
`;

export const CustomPriceLabel = styled.div`
  font-size: 14px;
  line-height: 14px;
  position: relative;

  strong {
    font-size: 32px;
    font-weight: 700;
    line-height: 33px;
  }
`;

export const ModalLink = styled.button`
  background-color: transparent;
  border: none;
  color: #696d8c;
  cursor: pointer;
  font-size: 14px;
  line-height: 17px;
  padding: 0;
  text-decoration: underline;
`;

export const Commission = styled(Text)`
  span {
    border-top: 1px solid #f3f3fc;
    padding-top: 10px;
  }
`;

export const ValueContainer = styled.div`
  color: #312f4f;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  padding-bottom: 8px;
  position: relative;
  text-align: left;
  width: fit-content;

  strong {
    font-family: Soleil;
    font-size: 32px;
    font-weight: 700;
    line-height: 33px;
    text-align: left;
  }
  h3 {
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    text-align: left;
  }
`;

export const CustomBadgeValue = styled.div`
  align-items: center;
  background: #c9ffee;
  border-radius: 4px;
  color: #086a4c;
  display: flex;
  font-weight: 700;
  justify-content: center;
  justify-content: space-around;
  line-height: 100%;
  padding: 4px 6px;
  position: absolute;
  right: -90%;
  top: 40%;
  white-space: nowrap;

  &:before {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid #c9ffee;
    content: '';
    left: -16%;
    position: absolute;
    top: 30%;
    transform: rotate(90deg);
    width: 0;
  }
`;
